
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Les études sur les vaccins contre le coronavirus n’en sont pas toutes au même
stade et la liste des effets secondaires n’a pas encore été publiée pour tous.
Après leur commercialisation, les produits continuent de faire l’objet d’un
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/covid-19-vaccines-safety-update.html"
      }}>{`suivi`}</a>{`
rapproché par les autorités helvétiques et d’éventuels effets secondaires
doivent être signalés.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;